<template>
  <div class="container">

    <breadcrumb-group :items="breadcrumbItems"/>
    <heading-one>お客さま情報の確認・変更</heading-one>

    <section>
      <heading-two class="_mt-50">お客さま情報</heading-two>
      <table-box class="_mb-md-60 _mb-sm-30">
        <table-body>
          <table-row>
            <table-header>
              お客さま番号
              <btn-tooltip slot="tooltip" target="numberTooltip" class="-question"></btn-tooltip>
              <tooltips-item slot="tooltip" target="numberTooltip" placement="righttop" clazz="question-box">
                ※お問い合わせの際にオペレーターに伝えていただく番号です。
              </tooltips-item>
            </table-header>
            <table-data>
              {{userData.account_id}}
            </table-data>
          </table-row>
          <table-row>
            <table-header>
              氏名<small>（漢字）</small>
              <btn-tooltip slot="tooltip" target="kanjiTooltip" class="-question"></btn-tooltip>
              <tooltips-item slot="tooltip" target="kanjiTooltip" placement="righttop" clazz="question-box">
                ご結婚などにより改姓した場合は、コールセンターへご連絡ください。
              </tooltips-item>
            </table-header>
            <table-data>
              {{userData.name_kanji}}
            </table-data>
          </table-row>
          <table-row>
            <table-header>
              氏名<small>（フリガナ）</small>
              <btn-tooltip slot="tooltip" target="kanaTooltip" class="-question"></btn-tooltip>
              <tooltips-item slot="tooltip" target="kanaTooltip" placement="righttop" clazz="question-box">
                ご結婚などにより改姓した場合は、コールセンターへご連絡ください。
              </tooltips-item>
            </table-header>
            <table-data>
              {{userData.name_kana}}
            </table-data>
          </table-row>
          <table-row>
            <table-header>
              生年月日
            </table-header>
            <table-data>
              {{displayBth}}
            </table-data>
          </table-row>
          <!--<table-row>
            <table-header>
              性別
            </table-header>
            <table-data>
              {{displaySex}}
            </table-data>
          </table-row>-->
          <table-row v-if="auUser && hasPhoneAu">
            <table-header>
              au携帯電話番号または<br>UQ mobile 電話番号
            </table-header>
            <table-data>
              {{displayPhoneAu}}
            </table-data>
          </table-row>
          <table-row>
            <table-header>
              電話番号<small>（その他）</small>
            </table-header>
            <table-data>
              {{displayPhoneMobile}}
            </table-data>
          </table-row>
          <!--<table-row>-->
            <!--<table-header>-->
              <!--au PAY プリペイドカード-->
              <!--<btn-tooltip slot="tooltip" target="mailTooltip" class="-question"></btn-tooltip>-->
              <!--<tooltips-item slot="tooltip" target="mailTooltip" placement="righttop" clazz="question-box">-->
                <!--ご利用中のau PAY プリペイドカード情報については、<br /><a href="https://wallet.auone.jp/index.html" target="_blank">au PAY サイト</a>をご確認ください。-->
              <!--</tooltips-item>-->
            <!--</table-header>-->
            <!--<table-data>-->
              <!--登録あり-->
            <!--</table-data>-->
          <!--</table-row>-->
          <table-row>
            <table-header>
              毎月のご返済日
            </table-header>
            <table-data>
              毎月{{userData.contractual_repayment_cycle}}日
              <!--{{displayRepaymentDate}}-->
            </table-data>
          </table-row>
        </table-body>
      </table-box>

      <card-groups class="_mb-md-60 _mb-sm-30">
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.accordion1 class="-plus">
              <h3 class="heading">ご自宅情報</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="accordion1" accordion="accordion">
            <card-body>
              <btngroup-single class="-pcnone _mb-md-40 _mb-sm-20">
                <!--<btn-main class="-normal" routerName="mb024">-->
                <btn-main class="-normal" routerName="mb024">
                  変更する
                </btn-main>
              </btngroup-single>
              <table-box class="_mb-md-20 _mb-sm-10">
                <table-body>
                  <table-row>
                    <table-header>
                      郵便番号
                    </table-header>
                    <table-data>
                      〒{{displayPostcode}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-header>
                      ご住所<small>（漢字）</small>
                    </table-header>
                    <table-data>
                      {{displayAddress}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-header>
                      ご住所<small>（フリガナ）</small>
                    </table-header>
                    <table-data>
                      {{userData.address_kana}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-header>
                      お住まいの種類
                    </table-header>
                    <table-data>
                      {{displayHomeType}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-header>
                      居住開始年月
                    </table-header>
                    <table-data>
                      {{displayNkyNgt}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-header>
                      住宅ローンもしくは家賃のお支払い<small>（月額）</small>
                    </table-header>
                    <table-data>
                      {{displayRentLoanAmount}}
                    </table-data>
                  </table-row>
                </table-body>
              </table-box>
              <table-box class="_mb-md-60 _mb-sm-30">
                <table-body>
                  <table-row>
                    <table-header>
                      ご家族（配偶者さま）
                    </table-header>
                    <table-data>
                      {{displayMarriageStatus}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-header>
                      ご家族（お子さま）
                    </table-header>
                    <table-data>
                      {{displayNumberOfChildren}}
                    </table-data>
                  </table-row>
                </table-body>
              </table-box>
              <btngroup-single class="_mb-md-40 _mb-sm-20">
                <!--<btn-main class="-normal" routerName="mb024">-->
                <btn-main class="-normal" routerName="mb024">
                  変更する
                </btn-main>
              </btngroup-single>
            </card-body>
          </collapse-item>
        </card-box>
      </card-groups>

      <heading-two class="_mt-50">メールアドレス情報</heading-two>
      <card-groups class="_mb-md-60 _mb-sm-30">
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.accordion2 class="-plus">
              <h3 class="heading">メールアドレス・お知らせ通知設定</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="accordion2" accordion="accordion" visible="true">
            <card-body>
              <btngroup-single class="-pcnone _mb-md-40 _mb-sm-20">
                <btn-main class="-normal" routerName="mb026">
                  変更する
                </btn-main>
              </btngroup-single>
              <table-box>
                <table-body>
                  <template v-if="showDefaultMail">
                    <table-row>
                      <table-header rowspan="3">
                        メールアドレス※
                        <tooltips-item slot="tooltip" target="mailTooltip" placement="righttop" clazz="question-box">
                          au IDにご登録の連絡先メールアドレスを表示しております。<br />変更をご希望の場合は、<a href="https://id.auone.jp/" class="-underline">au IDサイト</a>にて連絡先メールアドレスをご登録ください。
                        </tooltips-item>
                      </table-header>
                      <table-data>
                        {{displayEzMail}}
                      </table-data>
                    </table-row>
                    <table-row>
                      <table-data>
                        {{displayMail1}}
                      </table-data>
                    </table-row>
                    <table-row>
                      <table-data>
                        {{displayMail2}}
                      </table-data>
                    </table-row>
                  </template>
                  <table-row>
                    <table-header>
                      メールアドレス
                    </table-header>
                    <table-data>
                      {{displayLoanMail}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-header>
                      お知らせ通知設定
                    </table-header>
                    <table-data>
                      現在ご登録いただいているお知らせ通知設定を表示しています。<br />
                      <template v-if="userData.cpn_ukt_flg === '1'">・キャンペーン情報<br /></template>
                      <template v-if="userData.kri_tti_ukt_flg === '1'">・お借り入れ時<br /></template>
                      <template v-if="userData.hen_soku_ukt_flg === '1'">・ご返済時<br /></template>
                      <template v-if="userData.mns_stm_ukt_flg === '1'">・マンスリーステートメント発行<br /></template>
                    </table-data>
                  </table-row>
                </table-body>
              </table-box>
              <div class="_mb-md-60 _mb-sm-30"><small>※au IDにご登録の連絡先メールアドレスを表示しております。変更をご希望の場合は、<a href="https://id.auone.jp/" class="btn-text textlink" target="_blank">au IDサイト</a>にて連絡先メールアドレスをご登録ください。</small></div>
                <btngroup-single class="_mb-md-40 _mb-sm-20">
                <!--<btn-main class="-normal" routerName="mb026">-->
                <btn-main class="-normal" routerName="mb026">
                  変更する
                </btn-main>
              </btngroup-single>
            </card-body>
          </collapse-item>
        </card-box>
      </card-groups>
      <heading-two class="_mt-50">お勤め先情報</heading-two>
      <card-groups class="_mb-md-120 _mb-sm-60">
        <card-box>
          <card-header>
            <btn-toggle v-b-toggle.accordion3 class="-plus">
              <h3 class="heading">お勤め先情報</h3>
            </btn-toggle>
          </card-header>
          <collapse-item id="accordion3" accordion="accordion">
            <card-body>
              <btngroup-single class="-pcnone _mb-md-40 _mb-sm-20">
                <!--<btn-main class="-normal" routerName="mb025">-->
                <btn-main class="-normal" routerName="mb025">
                  変更する
                </btn-main>
              </btngroup-single>
              <table-box class="_mb-md-60 _mb-sm-30">
                <table-body>
                  <table-row>
                    <table-header>
                      職業
                    </table-header>
                    <table-data>
                      {{displayWorkForm}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-header>
                      業種
                    </table-header>
                    <table-data>
                      {{displayBizType}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-header>
                      職種
                    </table-header>
                    <table-data>
                      {{displayJobType}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-header>
                      お勤め先
                    </table-header>
                    <table-data>
                      {{userData.office_nm}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-header>
                      お勤め先電話番号
                    </table-header>
                    <table-data>
                      {{displayOfficePhone}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-header>
                      所属部署
                    </table-header>
                    <table-data>
                      {{userData.office_depart}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-header>
                      入社年月
                    </table-header>
                    <table-data>
                      {{displayNshNgt}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-header>
                      社員数
                    </table-header>
                    <table-data>
                      {{displayStaffNum}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-header>
                      年収（税込）
                      <btn-tooltip slot="tooltip" target="grossSalaryTooltip" class="-question"></btn-tooltip>
                      <tooltips-item slot="tooltip" target="grossSalaryTooltip" placement="righttop" clazz="question-box">
                        ※収入証明書をご提出いただいた場合、書類の確認結果によって年収が更新されることがあります。
                      </tooltips-item>
                    </table-header>
                    <table-data>
                      {{displayGrossSalary}}
                    </table-data>
                  </table-row>
                </table-body>
              </table-box>
              <btngroup-single class="_mb-md-40 _mb-sm-20">
                <!--<btn-main class="-normal" routerName="mb025">-->
                <btn-main class="-normal" routerName="mb025">
                  変更する
                </btn-main>
              </btngroup-single>
            </card-body>
          </collapse-item>
        </card-box>
      </card-groups>
    </section>

  </div><!-- container -->
</template>

<script>
import { getUserDataLambdaInvoke, deleteTmpUserDataLambdaInvoke } from '../utils/LambdaHelper'
import userData from '../components/mixin/UserData'

import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import TableData from '../components/tables/TableData'
import HeadingOne from '../components/heading/HeadingOne'
import HeadingTwo from '../components/heading/HeadingTwo'
import HeadingThree from '../components/heading/HeadingThree'
import BtnTooltip from '../components/button/BtnTooltip'
import TooltipsItem from '../components/tooltip/TooltipsItem'
import CardGroups from '../components/card/CardGroups'
import CardHeader from '../components/card/CardHeader'
import CardBody from '../components/card/CardBody'
import CardBox from '../components/card/CardBox'
import BtnToggle from '../components/button/BtnToggle'
import CollapseItem from '../components/collapse/CollapseItem'
import BtnMain from '../components/button/BtnMain'
import BtngroupSingle from '../components/button/BtngroupSingle'
export default {
  name: 'Mb-023',
  metaInfo: {
    title: 'お客さま情報の確認・変更｜ご登録情報',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,お客さま情報'}
    ]
  },
  mixins: [userData],
  components: {
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    HeadingOne,
    HeadingTwo,
    HeadingThree,
    BtnTooltip,
    TooltipsItem,
    CardGroups,
    CardHeader,
    CardBody,
    CardBox,
    BtnToggle,
    CollapseItem,
    BtnMain,
    BtngroupSingle
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'mb001'
      },
      {
        text: 'お客さま情報の確認・変更',
        active: true
      }
      ],
      hasPhoneMobile: false,
      hasPhoneAu: false,
      userData: {
        id_type: '',
        account_id: '',
        name_kanji: '',
        name_kana: '',
        lastname_kanji: '',
        firstname_kanji: '',
        lastname_kana: '',
        firstname_kana: '',
        bth: '',
        sex: '',
        phone_au_1: '',
        phone_au_2: '',
        phone_au_3: '',
        phone_mobile_1: '',
        phone_mobile_2: '',
        phone_mobile_3: '',
        repayment_date: '',
        contractual_repayment_cycle: '',
        // ご自宅情報
        postcode: '',
        address_region: '',
        address_city: '',
        address_street: '',
        address_building: '',
        address_kana: '',
        home_type: '',
        nky_ngt: '',
        rent_loan_amount: '',
        marriage_status: '',
        number_of_children: '',
        // メールアドレス情報
        ez_mail: '',
        mail_1: '',
        mail_2: '',
        loan_mail: '',
        cpn_ukt_flg: '',
        hen_soku_ukt_flg: '',
        kri_tti_ukt_flg: '',
        mns_stm_ukt_flg: '',
        // お勤め先情報
        work_form: '',
        biz_type: '',
        job_type: '',
        office_nm: '',
        office_phone_1: '',
        office_phone_2: '',
        office_phone_3: '',
        office_depart: '',
        nsh_ngt: '',
        staff_num: '',
        gross_salary: ''
      }
    }
  },
  mounted () {
    try {
      deleteTmpUserDataLambdaInvoke().then(res => {
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
    try {
      getUserDataLambdaInvoke().then(res => {
        for (let key in res) {
          if (this.userData.hasOwnProperty(key)) {
            this.userData[key] = res[key].toString().trim()
          }
        }
        this.setHasPhoneAu()
        this.setHasPhoneMobile()
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";
  .-underline {
    text-decoration: underline;
  }
  .btn-text {
    &:hover {
      text-decoration: underline;
      color: $orange !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Mb023.vue